import { css } from '@emotion/react'
import { HStack, Stack } from 'components/Stack'
import { Text } from 'components/Typography'
import { pxToRemUnit } from 'utils/styled'

export function CaptionedMediaMentions(props: {
  mentions: { logo: { url: string | undefined }; caption?: string | null }[]
  className?: string
}) {
  return (
    <HStack
      space={'2rem'}
      css={css`
        align-items: start;
        justify-content: center;
      `}
      className={props.className}
    >
      {props.mentions.map((mention) => (
        <Stack
          space={pxToRemUnit(10)}
          css={css`
            flex: 1;
            text-align: center;
            max-width: 180px;
            width: max-content;
          `}
          key={mention.logo.url}
        >
          <div
            css={css`
              display: flex;
              align-items: center;
              justify-content: center;
              height: 2rem;
            `}
          >
            <img
              src={mention.logo.url}
              css={css`
                height: 100%;
              `}
            />
          </div>
          <Text variant={'bodyMedium'}>{mention.caption || ''}</Text>
        </Stack>
      ))}
    </HStack>
  )
}
